import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { ErrorMessage } from 'types';
import { PaymentMethodSetupIntent } from 'types/generated/models/PaymentMethodSetupIntent';
import { client } from 'utils/api-client';

interface IUseSetupPaymentMethodIntent {
  athleteId?: string;
  enabled: boolean;
}

function useSetupPaymentMethodIntent({
  athleteId,
  enabled,
}: IUseSetupPaymentMethodIntent): UseQueryResult<
  AxiosResponse<PaymentMethodSetupIntent>,
  AxiosError<ErrorMessage>
> {
  return useQuery(
    ['paymentMethodsSetupIntent', athleteId],
    () => client.get(`/payment-methods/setup-intent/?athlete_id=${athleteId}`),
    {
      enabled: enabled && !!athleteId,
      refetchOnWindowFocus: false,
      retry: false,
      cacheTime: 0,
    },
  );
}

export default useSetupPaymentMethodIntent;
